import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import * as React from 'react';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const InputWithButton = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const [fileName, setFileName] = React.useState<string | null>(null);

    const handleFileClick = () => {
      document.getElementById(props.id || '')?.click();
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files ? event.target.files[0] : null;
      setFileName(file ? file.name : null);
      if (props.onChange) {
        props.onChange(event);
      }
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
      event.preventDefault();
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        const inputElement = document.getElementById(
          props.id || '',
        ) as HTMLInputElement;
        if (inputElement) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(files[0]);
          inputElement.files = dataTransfer.files;
          const changeEvent = new Event('change', { bubbles: true });
          inputElement.dispatchEvent(changeEvent);
          setFileName(files[0].name);
        }
      }
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
      event.preventDefault();
    };

    return (
      <div className="flex items-center gap-2">
        <input
          type={type}
          className={cn(
            'hidden', // Hide the default file input
            className,
          )}
          ref={ref}
          {...props}
          onChange={handleFileChange}
        />
        {type === 'file' && (
          <div
            className="flex h-10 w-full items-center rounded-lg border border-gray-300 text-sm text-gray-500 transition-colors duration-200 hover:border-gray-400"
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            <Button
              type="button"
              variant="default" // or "link" depending on your styling
              onClick={handleFileClick}
              className="ml-1 h-[80%] bg-blue-500 px-4 text-white transition-colors duration-200 hover:bg-blue-600"
            >
              Choose File
            </Button>
            <div className="flex-1 px-4 text-center">
              {fileName ? fileName : 'Drag & Drop File Here'}
            </div>
          </div>
        )}
      </div>
    );
  },
);

InputWithButton.displayName = 'InputWithButton';

export { InputWithButton };
